import CustomImage from '@src/components/CustomImage';
import edenredLogo from '@src/assets/images/login/logo-edenred@3x.png';

import { Text } from '@src/components';

const Survey = () => {
  return (
    <div style={styles.container}>
      <CustomImage src={edenredLogo} alt="Teşekkürler" style={styles.image} />
      <p style={styles.text}>
        <Text t="thankYouForYourResponse" />
      </p>
    </div>
  );
};

const styles = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    height: '100vh',
    textAlign: 'center',
    fontFamily: 'UbuntuLight, sans-serif',
    padding: '0 20px',
    boxSizing: 'border-box',
  },
  image: {
    maxWidth: '100%',
    height: 'auto',
    marginBottom: '20px',
  },
  text: {
    fontSize: '50px',
    margin: '0',
    padding: '0',
    lineHeight: '1.2',
    '@media (max-width: 768px)': {
      fontSize: '40px',
    },
    '@media (max-width: 480px)': {
      fontSize: '20px',
    },
  },
};

export default Survey;
